import type { SubscriptionProduct } from '@forest/native-services'

// Whether a non-subscriber can start a free trial — the signal that routes them
// to trial-paywall rather than permanent-paywall. Per-user: the store reports
// `eligible_trial_days` as 0 once a trial has been consumed. See CONTEXT.md ›
// Trial eligibility (this moves to an offer-level field once the product-level
// one is phased out).
export function isTrialEligible(products: SubscriptionProduct[]): boolean {
  return products.some((p) => p.eligible_trial_days > 0)
}
